import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearGlobalError } from '../../../store/app-status-slice';
import { errorSvg } from './svg';
const RefreshNow = ({ errorType }) => {
    const isOffline = errorType === 'offline';
    const isServerError = errorType === 'server';
    const dispatch = useDispatch();
    const handleRetry = () => {
        dispatch(clearGlobalError());
        window.location.reload();
    };

    return (
        <div className="fixed inset-0 z-50 bg-white flex flex-col justify-center items-center text-center px-6">
            <div className="">
                {errorSvg}
            </div>
            <h2 className="text-2xl font-semibold mb-2 -mt-6">
                {' '}
                {isOffline ? "You're offline" : "We'll be back shortly"}
            </h2>
            <p className="text-gray-400 mb-4 text-base">
                {' '}
                {isOffline
                    ? 'Please check your internet connection.'
                    : "We're fixing a temporary glitch. Sorry for the inconvenience."}
            </p>
            <button
                onClick={handleRetry}
                className="bg-primary text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-all text-[18px]"
            >
                Refresh Now
            </button>
        </div>
    );
};

export default RefreshNow;
